if (!customElements.get('bestbongz-video-hero')) {
  class BestBongzVideoHero extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.videos = Array.from(this.querySelectorAll('.bb-video-hero__video'));
      this.toggle = this.querySelector('.bb-video-hero__toggle');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.userPaused = false;

      if (!this.videos.length) return;

      this.handleViewportChange = this.syncPlayback.bind(this);
      this.handleVisibilityChange = this.onVisibilityChange.bind(this);
      this.handleToggle = this.togglePlayback.bind(this);
      this.handlePlaybackEvent = this.onPlaybackEvent.bind(this);
      this.handleCanPlay = this.onCanPlay.bind(this);

      this.videos.forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.addEventListener('playing', this.handlePlaybackEvent);
        video.addEventListener('pause', this.handlePlaybackEvent);
        video.addEventListener('canplay', this.handleCanPlay);
      });

      if (this.toggle) this.toggle.addEventListener('click', this.handleToggle);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      this.addMediaQueryListener(this.mobileQuery, this.handleViewportChange);

      this.syncPlayback();
    }

    disconnectedCallback() {
      if (!this.videos || !this.videos.length) return;
      if (this.toggle) this.toggle.removeEventListener('click', this.handleToggle);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.removeMediaQueryListener(this.mobileQuery, this.handleViewportChange);
      this.videos.forEach((video) => {
        video.removeEventListener('playing', this.handlePlaybackEvent);
        video.removeEventListener('pause', this.handlePlaybackEvent);
        video.removeEventListener('canplay', this.handleCanPlay);
      });
    }

    addMediaQueryListener(query, handler) {
      if (query.addEventListener) query.addEventListener('change', handler);
      else query.addListener(handler);
    }

    removeMediaQueryListener(query, handler) {
      if (query.removeEventListener) query.removeEventListener('change', handler);
      else query.removeListener(handler);
    }

    getActiveVideo() {
      const hiddenClass = this.mobileQuery.matches
        ? 'bb-video-hero__video--desktop'
        : 'bb-video-hero__video--mobile';

      return this.videos.find((video) => !video.classList.contains(hiddenClass)) || this.videos[0];
    }

    syncPlayback() {
      this.activeVideo = this.getActiveVideo();

      this.videos.forEach((video) => {
        if (video !== this.activeVideo) video.pause();
      });

      if (!this.userPaused && !document.hidden) this.playActiveVideo();
      else this.updatePlaybackState();
    }

    playActiveVideo() {
      if (!this.activeVideo) return;

      this.activeVideo.muted = true;
      const playPromise = this.activeVideo.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          this.updatePlaybackState();
        });
      }
    }

    togglePlayback() {
      if (!this.activeVideo) return;

      if (this.activeVideo.paused) {
        this.userPaused = false;
        this.playActiveVideo();
      } else {
        this.userPaused = true;
        this.activeVideo.pause();
      }
    }

    onVisibilityChange() {
      if (document.hidden) {
        if (this.activeVideo) this.activeVideo.pause();
      } else if (!this.userPaused) {
        this.playActiveVideo();
      }
    }

    onPlaybackEvent(event) {
      if (event.type === 'playing' && event.currentTarget !== this.activeVideo) {
        event.currentTarget.pause();
        return;
      }

      if (event.currentTarget === this.activeVideo) this.updatePlaybackState();
    }

    onCanPlay(event) {
      if (event.currentTarget === this.activeVideo && !this.userPaused && !document.hidden) {
        this.playActiveVideo();
      }
    }

    updatePlaybackState() {
      const isPaused = !this.activeVideo || this.activeVideo.paused;
      this.classList.toggle('is-paused', isPaused);

      if (!this.toggle) return;
      this.toggle.setAttribute('aria-label', isPaused ? 'Play background video' : 'Pause background video');
    }
  }

  customElements.define('bestbongz-video-hero', BestBongzVideoHero);
}
